import * as ss from 'superstruct';

export const EmailOutputStreamDestination = ss.type({
  name: ss.literal('email'),
  to: ss.string(),
});

export type EmailOutputStreamDestination = ss.Infer<
  typeof EmailOutputStreamDestination
>;
